// extracted by mini-css-extract-plugin
module.exports = {"bgText":"terms_bgText__2B6QI","texSection":"terms_texSection__15a6u","policyText":"terms_policyText__11t21","banner":"terms_banner__3-rt9","textContant":"terms_textContant__FEfPD"};